import type {TreeItem, TreeStructure} from '@pb/kit-component-tree-v2';
import type {DictionaryTree} from 'src/openapi/admin/models/DictionaryTree';

export const mapTree = (data: DictionaryTree, disabled?: boolean): TreeItem => {
    return {
        id: data.id,
        caption: data.description,
        disabled,
        ...data.children?.length
            ? ({children: data.children?.map(childData => mapTree(childData, disabled))})
            : null,
    };
};

export const getTreeStructure = (tree: DictionaryTree | null, disabled?: boolean): TreeStructure => {
    if (!tree) {
        return [];
    }

    return mapTree(tree, disabled)?.children as TreeStructure;
};
